import { useEffect, useState } from 'react';
import { api } from '../services/api';

// Bays at a location whose wash-controller reading is on (Settings -> Wash Equipment
// Integration). Drives the Chemical Usage "Valve" column and the Wash Replay menu item.
// Demo sites answer demo: true (emulated controller on every bay).
const TTL_MS = 60 * 1000;
const cache = new Map(); // locationId -> { at, value }

export function clearControllerBaysCache() {
  cache.clear();
}

export function useControllerBays(locationId) {
  const [value, setValue] = useState(() => cache.get(locationId)?.value || { bays: [], demo: false });

  useEffect(() => {
    if (!locationId) { setValue({ bays: [], demo: false }); return undefined; }
    const hit = cache.get(locationId);
    if (hit && Date.now() - hit.at < TTL_MS) { setValue(hit.value); return undefined; }
    let active = true;
    // Wrapped so a throw or a non-promise answer ends up in catch: the menu and Valve column just stay off.
    Promise.resolve().then(() => api.getControllerBays(locationId))
      .then(data => {
        const v = { bays: Array.isArray(data?.bays) ? data.bays : [], demo: Boolean(data?.demo) };
        cache.set(locationId, { at: Date.now(), value: v });
        if (active) setValue(v);
      })
      .catch(() => { if (active) setValue({ bays: [], demo: false }); });
    return () => { active = false; };
  }, [locationId]);

  return { ...value, hasController: value.demo || value.bays.length > 0 };
}
